type Env = {
  REACT_APP_AUTH_HOST: string;
  REACT_APP_CMS_GRAPHQL_HOST: string;
  REACT_APP_CMS_HOST: string;
  REACT_APP_TENANT_ID: string;
};

declare global {
  interface Window {
    env?: Partial<Env>;
  }
}

const wenv = (typeof window !== 'undefined' && window.env) || {};

export const ENV: Env = {
  REACT_APP_AUTH_HOST:
    (process.env.REACT_APP_AUTH_HOST as string) ||
    (wenv.REACT_APP_AUTH_HOST as string) ||
    'http://localhost:3334',
  REACT_APP_CMS_GRAPHQL_HOST:
    (process.env.REACT_APP_CMS_GRAPHQL_HOST as string) ||
    (wenv.REACT_APP_CMS_GRAPHQL_HOST as string) ||
    'http://localhost:3333/graphql',
  REACT_APP_CMS_HOST:
    (process.env.REACT_APP_CMS_HOST as string) ||
    (wenv.REACT_APP_CMS_HOST as string) ||
    'http://localhost:3333',
  REACT_APP_TENANT_ID:
    (process.env.REACT_APP_TENANT_ID as string) ||
    (wenv.REACT_APP_TENANT_ID as string) ||
    'default',
};
